<template>
  <section class="content">
    <div class="row">
      <div class="col-md-12">
        <div class="box box-primary">
          <div class="box-header with-border">
            <h3 class="box-title">
              <b>Consumo de Limites</b>
            </h3>
          </div>
          <div class="box-body">
            <div class="row">
              <div class="col-sm-8">
                <div class="form-group">
                  <label for>Unidade</label>
                  <select-unidade
                    @setUnidadeSelecionada="
                                            unidadeSelecionada => {
                                                setUnidadeSolicitante(unidadeSelecionada);
                                            }
                                        "
                  ></select-unidade>
                </div>
              </div>

              <div class="col-sm-4">
                <div class="form-group">
                  <label for>Competência</label>
                  <select v-model="filtros.distribuicao_id" class="form-control" name id>
                    <option
                      v-for="(item, index) in distribuicoes"
                      :key="index"
                      :value="item.id"
                    >{{ item.data_competencia | competencia }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="row" ref="filtrar">
              <div class="col-sm-12">
                <button
                  :disabled="!finalizado"
                  @click="getDataTable()"
                  data-toggle="tooltip"
                  title="Pesquisar Relatório de Solicitação"
                  id="resultado"
                  class="btn btn-primary pull-right"
                >
                  <i class="fa fa-search"></i> Pesquisar
                </button>
              </div>
            </div>
            <br />
            <div class="row" style="margin-top:15px">
              <div class="col-md-12">
                <div class="table-responsive form-group">
                  <table role="grid" class="table table-bordered">
                    <thead>
                      <tr>
                        <th>UNIDADE</th>
                        <th colspan="3" style="text-align: center;">LIMITE POR GERAL</th>
                        <th colspan="3" style="text-align: center;">LIMITE POR PROCEDIMENTO</th>
                        <th colspan="3" style="text-align: center;">LIMITE POR SUBGRUPO</th>
                        <th colspan="3" style="text-align: center;">LIMITE TOTAL</th>
                      </tr>
                      <tr>
                        <th>---</th>
                        <th>Total</th>
                        <th>Consumido</th>
                        <th>Disponível</th>

                        <th>Total</th>
                        <th>Consumido</th>
                        <th>Disponível</th>

                        <th>Total</th>
                        <th>Consumido</th>
                        <th>Disponível</th>

                        <th>Total</th>
                        <th>Consumido</th>
                        <th>Disponível</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item, index) in dataTable.data" :key="index">
                        <td>{{ item.unidade.nome }}</td>

                        <td>{{ (parseFloat(item.limite_geral) + parseFloat(item.total_consumido_geral)) | numberFormat(2,',','.') }}</td>
                        <td>{{ parseFloat(item.total_consumido_geral) | numberFormat(2,',','.') }}</td>
                        <td>{{ parseFloat(item.limite_geral) | numberFormat(2,',','.') }}</td>

                        <td>{{ (parseFloat(item.total_disponivel_procedimento) + parseFloat(item.total_consumido_procedimento)) | numberFormat(2,',','.') }}</td>
                        <td>{{ parseFloat(item.total_consumido_procedimento) | numberFormat(2,',','.') }}</td>
                        <td>{{ parseFloat(item.total_disponivel_procedimento) | numberFormat(2,',','.') }}</td>

                        <td>{{ (parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_consumido_subgrupo)) | numberFormat(2,',','.') }}</td>
                        <td>{{ parseFloat(item.total_consumido_subgrupo) | numberFormat(2,',','.') }}</td>
                        <td>{{ parseFloat(item.total_disponivel_subgrupo) | numberFormat(2,',','.') }}</td>

                        <td>
                          <strong>{{ (parseFloat(item.limite_geral) + parseFloat(item.total_consumido_geral) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.total_consumido_procedimento)+ parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_consumido_subgrupo)) | numberFormat(2,',','.')}}</strong>
                        </td>
                        <td>
                          <strong>{{ (parseFloat(item.total_consumido_subgrupo) + parseFloat(item.total_consumido_procedimento) + parseFloat(item.total_consumido_geral)) | numberFormat(2,',','.') }}</strong>
                        </td>
                        <td>
                          <strong
                            style="color: green"
                            v-if="(parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)) > 0"
                          >{{ (parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)) | numberFormat(2,',','.') }}</strong>
                          <strong
                            v-if="(parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)) == 0"
                          >{{ (parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)) | numberFormat(2,',','.') }}</strong>
                          <strong
                            style="color: red"
                            v-if="(parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)) < 0"
                          >{{ (parseFloat(item.total_disponivel_subgrupo) + parseFloat(item.total_disponivel_procedimento) + parseFloat(item.limite_geral)) | numberFormat(2,',','.') }}</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div class="row" v-if="dataTable.data && dataTable.data.length > 0">
                  <div
                    class="col-sm-4"
                  >Mostrando {{ this.dataTable.from }} até {{ this.dataTable.to }} de {{ this.dataTable.total }} registros encontrados.</div>
                  <div class="col-sm-6" style="text-align:right">
                    <laravue-pagination
                      :limit="5"
                      :data="dataTable"
                      v-on:pagination-change-page="getDataTable"
                    >
                      <span slot="prev-nav">&lt; Anterior</span>
                      <span slot="next-nav">Próximo &gt;</span>
                    </laravue-pagination>
                  </div>
                  <div class="col-sm-2 text-right"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import axios from "axios"; // Cliente para requisição http
import selectUnidade from "@/components/cadastros/unidades/selectUnidade";

export default {
  components: {
    selectUnidade
  },

  data: () => ({
    pdf: null,
    heigthPdf: 900,
    filtros: {
      distribuicao_id: '',
      unidade_id: ''
    },
    distribuicoes: [],
    dataTable: {},
    finalizado: true,
  }),

  mounted() {
    this.getDistribuicoes();
  },

  methods: {
    getDataTable(page) {
      this.$swal({
        title: "Aguarde!",
        text: "Essa consulta pode demorar um pouco",
        imageUrl: "/static/img/Rolling-green.gif",
        showConfirmButton: false,
        allowOutsideClick: false
      });
      if (typeof page === "undefined") {
        page = 1;
      }

      this.filtros.page = page;
      let config = this.$store.getters.getHeaderAuth;
      config.params = this.filtros;

      axios
        .get(
          `${this.$store.state.serverURI}/api/relatorios/consumo-limites`,
          config
        )
        .then(response => {
          this.dataTable = response.data;
        })
        .catch(error => {
          console.log(error);
        })
        .finally(() => {
          this.$swal.close();
        });
    },
    getDistribuicoes() {
      axios
        .get(
          `${this.$store.state.serverURI}/api/distribuicao/getAll`,
          this.$store.getters.getHeaderAuth
        )
        .then(response => {
          this.distribuicoes = response.data;
          this.filtros.distribuicao_id = this.distribuicoes[0].id;
          this.getDataTable();
        })
        .catch(error => {
          console.log(error);
        });
    },
    setUnidadeSolicitante(unidadeSolicitante) {
      this.filtros.unidade_id = unidadeSolicitante.id;
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// index.vue?51f9b0b4